import React, { useState } from 'react';
import { SlidersHorizontal, Play, X, DollarSign, Phone, Factory, Users } from 'lucide-react';

// Helper component for a single slider
const PrioritySlider = ({ label, icon: Icon, value, onChange, colorClass }) => (
    <div className="space-y-2">
        <div className="flex justify-between items-center">
            <label className="flex items-center font-medium text-gray-700">
                <Icon className={`w-5 h-5 mr-2 ${colorClass}`} />
                {label}
            </label>
            <span className={`font-semibold text-sm px-2 py-0.5 rounded-md bg-gray-200 text-gray-800`}>{value}%</span>
        </div>
        <input
            type="range"
            min="0"
            max="100"
            step="5"
            value={value}
            onChange={onChange}
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
        />
    </div>
);

export const PriorityModal = ({ scenarioTitle, onStart, onClose }) => {
    const [priorities, setPriorities] = useState({
        cash: 50,
        reputation: 50,
        operational_capacity: 50,
        stakeholder_confidence: 50,
    });

    const handleSliderChange = (key, value) => {
        setPriorities(prev => ({ ...prev, [key]: parseInt(value, 10) }));
    };

    const handleStart = () => {
        onStart(priorities);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose}>
            <div className="bg-white rounded-lg shadow-2xl p-8 max-w-lg w-full relative" onClick={e => e.stopPropagation()}>
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-700">
                    <X className="w-6 h-6" />
                </button>
                
                <div className="flex items-center gap-4 mb-4">
                    <SlidersHorizontal className="w-8 h-8 text-blue-600 flex-shrink-0" />
                    <div>
                        <h2 className="text-2xl font-bold text-gray-900">Set Strategic Priorities</h2>
                        <p className="text-gray-600">For the upcoming scenario: <span className="font-semibold">{scenarioTitle}</span></p>
                    </div>
                </div>

                <p className="text-sm text-gray-600 mb-6">
                    Adjust the sliders to reflect your team's strategic focus. The AI's post-simulation analysis will be tailored based on these weights.
                </p>

                <div className="space-y-6 mb-8">
                    <PrioritySlider label="Cash Reserves" icon={DollarSign} value={priorities.cash} onChange={(e) => handleSliderChange('cash', e.target.value)} colorClass="text-green-600" />
                    <PrioritySlider label="Reputation" icon={Phone} value={priorities.reputation} onChange={(e) => handleSliderChange('reputation', e.target.value)} colorClass="text-blue-600" />
                    <PrioritySlider label="Operational Capacity" icon={Factory} value={priorities.operational_capacity} onChange={(e) => handleSliderChange('operational_capacity', e.target.value)} colorClass="text-purple-600" />
                    <PrioritySlider label="Stakeholder Confidence" icon={Users} value={priorities.stakeholder_confidence} onChange={(e) => handleSliderChange('stakeholder_confidence', e.target.value)} colorClass="text-yellow-600" />
                </div>

                <button 
                    onClick={handleStart} 
                    className="w-full flex items-center justify-center px-4 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
                >
                    <Play className="w-5 h-5 mr-2" />
                    Start Simulation with These Priorities
                </button>
            </div>
        </div>
    );
};
